import { cB as t } from "./ghl-ui.es361.js";
const e = t("base-wave", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
`);
export {
  e as default
};
